import React from 'react';

import AboutSection from '@components/about-section';
import Layout from '@components/layout';
import HeroSection from '@components/hero-section';
import StationCarousels from '@components/station-carousels';
import LazyComponent from '@components/lazy-component';

const ProdajaDerivataPage = () => (
  <Layout pagePath="/prodaja-naftnih-derivata" pageTitle="Prodaja naftnih derivata" pageDescription="Maloprodaja nafte i naftnih derivata preko mreže benzinskih stanica na području Zvornika.">
    <HeroSection cn="pnd">
      <h1>Prodaja naftnih derivata</h1>
    </HeroSection>
    <AboutSection>
      <p>
        Osnovna djelatnost firme Keso-Promet d.o.o. je maloprodaja nafte i
        naftnih derivata preko maloprodajne mreže benzinskih stanica koje se
        nalaze na 4 atraktivne lokacije na području Zvornika - Zvornik, Karakaj,
        Tršić i Caparde.
      </p>
      <p>
        Uz maloprodaju nafte i naftnih derivata, na našim benzinskim stanicama
        nudimo i veliki izbor motornih ulja i derivata renomiranih svjetskih
        proizvođača, auto opreme i pribora, te veliku ponudu mješovite robe
        široke potrošnje.
      </p>
    </AboutSection>
    <StationCarousels />
    <LazyComponent path="stations-map" />
  </Layout>
);

export default ProdajaDerivataPage;
